import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import "./Layout.css";
import { API_ENDPOINTS } from '../config/api';
import useAutoLogout from '../hooks/useAutoLogout';

const Layout = () => {
  const location = useLocation();
  const isAdminPage = location.pathname !== '/' && location.pathname !== '/home';

  // 30 dakika (1800000ms) hareketsizlikte otomatik çıkış
  useAutoLogout(1800000);

  // Sayfa değiştiğinde scroll'u en üste al (Navigation için önemli)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const akademisyenId = sessionStorage.getItem('akademisyen_id');
    if (!akademisyenId) return;
    const send = () => {
      fetch(API_ENDPOINTS.ACTIVITY_HEARTBEAT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ akademisyen_id: parseInt(akademisyenId) })
      }).catch(() => { });
    };
    send();
    const i = setInterval(send, 60000);
    const end = () => {
      try {
        navigator.sendBeacon(
          API_ENDPOINTS.ACTIVITY_LOGOUT,
          new Blob([JSON.stringify({ akademisyen_id: parseInt(akademisyenId) })], { type: 'application/json' })
        );
      } catch { }
    };
    window.addEventListener('beforeunload', end);
    return () => {
      window.removeEventListener('beforeunload', end);
      clearInterval(i);
    };
  }, [location.pathname]);

  return (
    <div className={isAdminPage ? 'layout-with-sidebar' : ''}>
      {isAdminPage && <Sidebar />}
      <main className={isAdminPage ? 'content-with-sidebar' : ''}>
        <Outlet />
      </main>
    </div>
  );
};



export default Layout;

